<section class="auth">
  <aside class="auth-panel">
    <p class="kicker light">{{ lang.t('upKicker') }}</p>
    <h1>{{ lang.t('upH') }}</h1>
    <p>{{ lang.t('upP') }}</p>
    <ol>
      <li><strong>{{ lang.t('inSpeed') }}</strong> {{ lang.t('inSpeedB') }}</li>
      <li><strong>{{ lang.t('inSec') }}</strong> {{ lang.t('inSecB') }}</li>
      <li><strong>{{ lang.t('inRel') }}</strong> {{ lang.t('inRelB') }}</li>
    </ol>
  </aside>

  <form class="auth-form" [formGroup]="form" (ngSubmit)="submit()">
    <p class="kicker">{{ lang.t('upTitle') }}</p>
    <h2>{{ lang.t('upH2') }}</h2>

    @if (serverError(); as message) {
      <p class="banner" role="alert">{{ message }}</p>
    }

    <label>
      {{ lang.t('upName') }}
      <input type="text" formControlName="name" autocomplete="name" />
      @if (form.controls.name.touched && form.controls.name.invalid) {
        <small>{{ lang.t('upNameErr') }}</small>
      }
    </label>

    <label>
      {{ lang.t('inEmail') }}
      <input type="email" formControlName="email" autocomplete="email" />
      @if (form.controls.email.touched && form.controls.email.invalid) {
        <small>{{ lang.t('upEmailErr') }}</small>
      }
    </label>

    <label>
      {{ lang.t('upPhone') }}
      <span class="phone-field">
        <span class="phone-code" (focusout)="closeCode($event)">
          <input type="hidden" formControlName="dial" />
          <button class="phone-code-btn" type="button" [attr.aria-label]="lang.t('upCode')" [attr.aria-expanded]="codeOpen()" (click)="toggleCode()">
            @if (dialCountry(); as chosen) {
              {{ flag(chosen.iso) }} +{{ chosen.dial }}
            } @else {
              {{ lang.t('upCodeShort') }}
            }
          </button>
          @if (codeOpen()) {
            <span class="phone-code-panel">
              <input id="phone-code-search" type="search" [attr.placeholder]="lang.t('upCodePh')" [value]="codeQuery()" (input)="setCodeQuery($event)" />
              <span class="phone-code-list" role="listbox">
                @for (item of codeMatches(); track item.iso) {
                  <button type="button" role="option" [attr.aria-selected]="item.iso === form.controls.dial.value" (click)="pickCode(item)">
                    {{ flag(item.iso) }} {{ item.name }} <span>+{{ item.dial }}</span>
                  </button>
                } @empty {
                  <span class="phone-code-empty">{{ lang.t('upNoCountry') }}</span>
                }
              </span>
            </span>
          }
        </span>
        <input type="tel" formControlName="national" inputmode="tel" autocomplete="tel-national" [attr.placeholder]="lang.t('upNumber')" />
      </span>
      @if (dialCountry(); as chosen) {
        <span class="phone-hint">{{ chosen.name }} · +{{ chosen.dial }}</span>
      }
      @if (form.controls.national.touched && form.controls.national.invalid) {
        @if (dialCountry(); as chosen) {
          <small>{{ lang.t('upReal') }} {{ chosen.name }} {{ lang.t('upReal2') }}</small>
        } @else {
          <small>{{ lang.t('upChooseCode') }}</small>
        }
      }
    </label>

    <label>
      {{ lang.t('upCountry') }}
      <select formControlName="country" autocomplete="country-name">
        <option value="" disabled>{{ lang.t('upSelect') }}</option>
        @for (item of countries; track item.iso) {
          <option [value]="item.iso">{{ flag(item.iso) }} {{ item.name }}</option>
        }
      </select>
      @if (form.controls.country.touched && form.controls.country.invalid) {
        <small>{{ lang.t('upCountryErr') }}</small>
      }
    </label>

    <div class="auth-grid">
      <label>
        {{ lang.t('inPass') }}
        <input type="password" formControlName="password" autocomplete="new-password" />
        @if (form.controls.password.touched && form.controls.password.invalid) {
          <small>{{ lang.t('upPassErr') }}</small>
        }
      </label>

      <label>
        {{ lang.t('upConfirm') }}
        <input type="password" formControlName="confirm" autocomplete="new-password" />
        @if (form.controls.confirm.touched && form.hasError('mismatch')) {
          <small>{{ lang.t('upMismatch') }}</small>
        }
      </label>
    </div>

    <button class="btn primary" type="submit" [disabled]="submitting()">
      {{ submitting() ? lang.t('upBusy') : lang.t('upCreate') }}
    </button>
    <p class="fine">{{ lang.t('upAlready') }} <a routerLink="/signin">{{ lang.t('inTitle') }}</a>.</p>
  </form>
</section>
